



















import { defineComponent, computed } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import PromptBar from './PromptBar.vue';

export default defineComponent({
  components: {
    PromptBar,
  },
  props: {
    timeLeft: {
      type: Number,
      default: 20,
    },
    sender: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
    },
    isDsr: {
      type: Boolean,
    },
  },
  setup(props) {
    const title = computed(() =>
      props.isDsr
        ? t('dsr_updated_room_title', {
            SenderName: props.sender,
          })
        : `${props.sender} ${t('has-modified-the-document')}`
    );

    const secondsText = computed(() => (props.timeLeft === 1 ? t('second') : t('seconds')));

    const description = computed(() =>
      props.isDsr
        ? `${t('dsr_updated_room_description')} ${props.timeLeft} ${secondsText.value}`
        : `${t('the-document-will-automatically-update-in')} ${props.timeLeft} ${secondsText.value}`
    );

    const cta = computed(() => (props.isDsr ? t('dsr_update_button') : t('review-new-version')));

    return {
      title,
      secondsText,
      description,
      cta,
    };
  },
});
